/// Globals

export const COMPANY_NAME = import.meta.env.VITE_COMPANY_NAME || "Eedi";

export const PLATFORM_NAME = import.meta.env.VITE_PLATFORM_NAME || "Eedi Tutor Dashboard";

// Currently used for:
// - disabling certain spam console.logs
// - some console assertions
export const PRODUCTION = import.meta.env.VITE_PRODUCTION || false;

/// SignalR

// Used as a unique web-lock, should not be shared with other projects
export const SIG_LOCK_NAME =
  import.meta.env.VITE_SIG_LOCK_NAME || COMPANY_NAME + "-tutor-signalr-lock";

export const SIG_FLOW_ENDPOINT =
  import.meta.env.VITE_SIG_FLOW_ENDPOINT || "https://flow-api-qa.eedi.com";

export const SIG_HUB_NAME = import.meta.env.VITE_SIG_HUB_NAME || "LessonHub";

/// API

export const API_MAIN = import.meta.env.VITE_API_MAIN || "https://api-qa.eedi.com";

export const API_FLOW = import.meta.env.VITE_API_FLOW || "https://flow-api-qa.eedi.com";

export const API_FUNC =
  import.meta.env.VITE_API_FUNC || "https://eedi-functions-api-qa.azurewebsites.net/api";

export const QUESTION_IMAGE_ENDPOINT =
  import.meta.env.VITE_QUESTION_IMAGE_ENDPOINT || "https://images.diagnosticquestions.com";

/// TEACHER
export const TEACHER_ENDPOINT = PRODUCTION
  ? "https://teacher.eedi.com/"
  : "https://teacher-qa.eedi.com/";

export const ADMIN_ENDPOINT = PRODUCTION
  ? "https://flow-admin.eedi.com/"
  : "https://eedi-tutor-qa-v2.azurewebsites.net/";

/// AI Tutor (the non-human proxy tutor that runs direct-AI, auto-moderated sessions)

// TutorId of the AI tutor proxy row in Tutors. Unset = no AI tutor in this environment.
export const AI_TUTOR_USER_ID =
  import.meta.env.VITE_AI_TUTOR_ID && Number.isFinite(Number(import.meta.env.VITE_AI_TUTOR_ID))
    ? Number(import.meta.env.VITE_AI_TUTOR_ID)
    : PRODUCTION
      ? 4769126
      : 3506182;

// UserId of the AI tutor proxy (session rows expose tutorUserId, not always tutorId).
export const AI_TUTOR_ID = import.meta.env.VITE_AI_TUTOR_USER_ID
  ? Number(import.meta.env.VITE_AI_TUTOR_USER_ID)
  : PRODUCTION
    ? 461
    : 140;

/// Misc

export const GOOGLE_AUTH_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_AUTH_CLIENT_ID ||
  "250963904963-e2uegfjodagts71r9lmv58j3ablqv6c6.apps.googleusercontent.com";

export const SENTRY_ENDPOINT =
  import.meta.env.VITE_SENTRY_ENDPOINT ||
  "https://bcf6cd3385ae99c4bcb60a238058245d@o84128.ingest.us.sentry.io/4511236105371648";

export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE || "unknown-sentry-build";

/// PRECONNECT

export const PRECONNECT_URLS = [
  "https://ca.slack-edge.com", // Images
  PRODUCTION // SignalR
    ? "https://eedi-prod-server.service.signalr.net"
    : "https://eedi-qa-server.service.signalr.net",
];

/// END
